export default __webpack_public_path__ + "static/media/Sara.e5462e29.jpg";